import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export type OnboardingFeatureStateType = {
  popup: boolean;
  video_page_builder: boolean;
  video_merchandise_and_price: boolean;
  video_theme_store: boolean;
  video_product: boolean;
  video_product_category: boolean;
  video_hot_category: boolean;
  blog: boolean;
  hot_category: boolean;
  seo: boolean;
  domain: boolean;
  popup_fnb_version: boolean;
  banner_fnb_version: boolean;
  url_redirect: boolean;
  popup_edit_multiple_page: boolean
};

export interface IDomainSettingType {
  domain: string;
  ip_address: string;
  is_show: boolean;
}

const initialState: {
  features: OnboardingFeatureStateType;
  domainSettings: IDomainSettingType;
} = {
  features: {} as OnboardingFeatureStateType,
  domainSettings: {} as IDomainSettingType,
};

export const OnboardingFeatureSlice = createSlice({
  name: "onboarding_feature",
  initialState,
  reducers: {
    setOnboardingSettings: (
      state,
      action: PayloadAction<{ value: OnboardingFeatureStateType }>
    ) => {
      state.features = { ...action.payload.value };
    },
    setDomainSettings: (
      state,
      action: PayloadAction<{ value: IDomainSettingType }>
    ) => {
      state.domainSettings = { ...action.payload.value };
    },
  },
});

export const { setOnboardingSettings, setDomainSettings } =
  OnboardingFeatureSlice.actions;

export const OnboardingFeature = (state: RootState) =>
  state.onboardingFeatures.features;
export const DomainSettingSlice = (state: RootState) =>
  state.onboardingFeatures.domainSettings;
export default OnboardingFeatureSlice.reducer;
